import { NavLink } from "react-router-dom";
import { Home, Radar, TrendingUp, BookOpen } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/fps-finder", label: "FPS Finder", icon: Radar },
  { to: "/price-index", label: "Prices", icon: TrendingUp },
  { to: "/guides", label: "Guides", icon: BookOpen },
];

export default function MobileNav() {
  return (
    <nav
      data-testid="mobile-thumb-nav"
      className="fixed bottom-3 left-4 right-4 z-50 flex items-center justify-around rounded-full border border-border bg-graphite/95 px-2 py-2 shadow-[0_8px_32px_rgba(0,0,0,0.8)] backdrop-blur-lg md:hidden"
    >
      {ITEMS.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          data-testid={`thumbnav-${label.replace(/\s+/g, "-").toLowerCase()}`}
          className={({ isActive }) =>
            `flex flex-1 flex-col items-center gap-0.5 rounded-full py-1.5 text-[10px] font-medium transition-colors ${
              isActive ? "text-neon" : "text-slate-400"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Icon className={`h-5 w-5 ${isActive ? "drop-shadow-[0_0_6px_rgba(57,255,20,0.7)]" : ""}`} />
              {label}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
